<template>
  <div>
    <div class="wraper" v-if="!isLoading">
      <div class="container-fluid mycontainer-fluid">
        <slot name="header"></slot>
        <ProjectHeader></ProjectHeader>

        <div class="row myrow">
          <div class="col-xs-12 mycol" style="padding-top: 10px;">
            <div class="pull-right">
              <a
                v-if="currentUser.IS_EXPERT_USER == 0 && isExpertiseView"
                target="_blank"
                :href="
                  'http://reporting/ReportServer/Pages/ReportViewer.aspx?/Отчеты/ДП/Результаты проведения экспертиз (светофор)&number=' +
                    project.UF_NUMBER +
                    '&rs:Command=Render&rc:Toolbar=true'
                "
                class="btn btn-success"
                style="margin-right: 12px"
                >Результаты проведения экспертиз</a
              >
            </div>
          </div>
        </div>
      </div>
      <div style="padding: 20px 30px;" v-if="isLoadingComponent">
        <div v-if="expertise.length > 0">
          <div
            class="row"
            v-for="(item, index) in expertise"
            :key="item.ID_TYPE_EXPERTISE"
            style="margin-bottom: 20px"
          >
            <div class="col-xs-12 col-sm-12 col-md-10 col-lg-8">
              <label>
                <input
                  type="checkbox"
                  v-if="expChecked !== null"
                  v-model="expChecked[index]"
                  :disabled="
                    currentUser.IS_EXPERT_DIRETOR !== 1 && !isExpertiseEditable
                  "
                />
                {{ item.NAME_EXPERTISE }}
              </label>
              <div v-for="exp in item.EXPERTISE_LIST" :key="exp.EXPERTISE_ID">
                <div
                  class="modal-content"
                  style="margin-bottom: 20px; margin-top: 20px;"
                >
                  <div class="modal-close-wrapp">
                    <button
                      v-if="isExpertiseEditable"
                      type="button"
                      class="close"
                      aria-label="Close"
                      @click="deleteExpertise(exp.EXPERTISE_ID)"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <!-- modal-close-wrapp -->
                  <div class="modal-body" style="padding-top: 2px;">
                    <div class="row stl-mb-10">
                      <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                        <div
                          class="stl-mb-5"
                          v-if="
                            exp.MANAGER_CREATE_INFO.UF_MANAGER_GREATE_NAME != ''
                          "
                        >
                          <span style="border-bottom: 1px dashed #000">
                            Экспертиза создана:
                            <strong>
                              {{
                                exp.MANAGER_CREATE_INFO.UF_MANAGER_GREATE_NAME
                              }}
                              <template
                                v-if="
                                  exp.MANAGER_CREATE_INFO.UF_GROUP_GREATE_NAME
                                "
                              >
                                роль "{{
                                  exp.MANAGER_CREATE_INFO.UF_GROUP_GREATE_NAME
                                }}"
                              </template>
                            </strong>
                          </span>
                        </div>

                        <div
                          class="stl-mb-5"
                          v-if="
                            experts !== null && experts[item.ID_TYPE_EXPERTISE]
                          "
                        >
                          Эксперт:
                          <strong>{{ exp.UF_EXPERT_NAME }}</strong>
                        </div>
                        <div
                          class="stl-mb-5"
                          v-if="
                            experts !== null && experts[item.ID_TYPE_EXPERTISE]
                          "
                        >
                          Дата назначения эксперта:
                          <strong>{{
                            exp.UF_DATE_CREATE_EXPERT_TO_EXPERTISE
                          }}</strong>
                        </div>

                        <div
                          class="stl-mb-5"
                          v-if="
                            experts !== null &&
                              experts[item.ID_TYPE_EXPERTISE] &&
                              isExpertiseEditable &&
                              exp.IS_VIEW_DOP_EXPERT
                          "
                        >
                          Дополнительный эксперт:
                          <strong>{{ exp.UF_EXPERT_DOP_NAME }}</strong>
                        </div>

                        <div
                          class="stl-mb-5"
                          v-if="
                            experts !== null &&
                              experts[item.ID_TYPE_EXPERTISE] &&
                              isExpertiseEditable &&
                              exp.IS_VIEW_DOP_EXPERT
                          "
                        >
                          Дата назначения дополнительного эксперта:
                          <strong>{{
                            exp.UF_DATE_CREATE_EXPERT_TO_EXPERTISE_DOP
                          }}</strong>
                        </div>

                        <div class="stl-mb-5">
                          {{
                            exp.IS_VIEW_DOP_EXPERT == 1
                              ? "Статус основной экспертизы"
                              : "Статус экспертизы"
                          }}:
                          <strong>
                            {{
                              getExpertiseStatusName(exp.UF_EXPERT_STATUS_ID)
                            }}
                          </strong>
                        </div>
                        <div
                          class="stl-mb-5"
                          v-if="exp.IS_VIEW_DOP_EXPERT == 1"
                        >
                          Статус дополнительной экспертизы:
                          <strong>
                            {{
                              getExpertiseStatusName(
                                exp.UF_EXPERT_STATUS_DOP_ID
                              )
                            }}
                          </strong>
                        </div>
                        <div
                          class="stl-mb-5"
                          v-if="
                            item.IS_SET_VARIANT_DOP_EXPERTISE === 1 &&
                              item.IS_ONLY_SET_DIRECTOR === 1
                          "
                        >
                          Вариант проведения экспертизы:
                          <strong>
                            {{
                              getTypeZalogExpertis(
                                exp.UF_VARIANT_DOP_EXPERTISE_ID
                              )
                            }}
                          </strong>
                        </div>
                        <div class="stl-mb-5">
                          Дата начала экспертизы:
                          <strong>{{ exp.UF_DATE_START_EXPERT }}</strong>
                        </div>
                        <div class="stl-mb-5" v-if="exp.UF_DATE_END_EXPERT">
                          {{
                            exp.IS_VIEW_DOP_EXPERT == 1
                              ? "Дата окончания основной экспертизы"
                              : "Дата окончания экспертизы"
                          }}:
                          <strong>{{ exp.UF_DATE_END_EXPERT }}</strong>
                        </div>
                        <div
                          class="stl-mb-5"
                          v-if="exp.IS_VIEW_DOP_EXPERT == 1"
                        >
                          Дата окончания дополнительной экспертизы:
                          <strong>{{ exp.UF_DATE_END_DOP_EXPERT }}</strong>
                        </div>
                        <form
                          class="form-inline stl-mb-5"
                          v-if="item.IS_SET_RESULT_EXPERTISES"
                        >
                          <div class="form-group">
                            <label>
                              {{
                                exp.IS_VIEW_DOP_EXPERT == 1
                                  ? "Результат основной экспертизы"
                                  : "Результат экспертизы"
                              }}: &nbsp;</label
                            >
                            <select
                              :id="'expertise_' + exp.EXPERTISE_ID"
                              v-if="
                                (exp.IS_VIEW_BUTTON_END ||
                                  exp.IS_SET_RESULT_EXPERTISE) &&
                                  exp.IS_MAIN_EXPERTISE
                              "
                              v-model="exp.UF_EXPERTISE_RESULT_ID"
                              class="form-control"
                              :disabled="!item.IS_ONLY_SET_DIRECTOR === 1"
                              @change="
                                saveResultExpertises(
                                  exp.EXPERTISE_ID,
                                  exp.UF_EXPERTISE_RESULT_ID,
                                  item.RESULT_EXPERTISE_SP,
                                  'expertise_' + exp.EXPERTISE_ID
                                )
                              "
                              :style="
                                'background:' +
                                  getCSSResult(
                                    item.RESULT_EXPERTISE_SP,
                                    exp.UF_EXPERTISE_RESULT_ID
                                  )
                              "
                            >
                              <option
                                v-for="expertiseResult in item.RESULT_EXPERTISE_SP"
                                v-if="
                                  (exp.IS_SET_NEW_RESULT_BY_SC == 1 &&
                                    expertiseResult.UF_IS_ONLY_SUSPENSIVE_CONDITION ===
                                      1) ||
                                    (exp.IS_SET_NEW_RESULT_BY_SC == 0 &&
                                      expertiseResult.UF_IS_ONLY_SUSPENSIVE_CONDITION !==
                                        1)
                                "
                                :style="
                                  `background-color: ${expertiseResult.UF_CSS_COLOR}`
                                "
                                :value="expertiseResult.ID"
                                :key="expertiseResult.ID"
                                >{{ expertiseResult.UF_NAME }}
                              </option>
                            </select>
                            <template v-else-if="exp.UF_EXPERTISE_RESULT_ID">
                              <template
                                v-for="expertiseResult in item.RESULT_EXPERTISE_SP"
                              >
                                <strong
                                  v-if="
                                    expertiseResult.ID ===
                                      exp.UF_EXPERTISE_RESULT_ID
                                  "
                                  :style="
                                    `background-color: ${expertiseResult.UF_CSS_COLOR}`
                                  "
                                >
                                  {{
                                    getExpertiseResult(
                                      exp.UF_EXPERTISE_RESULT_ID,
                                      item.RESULT_EXPERTISE_SP
                                    )
                                  }}
                                </strong>
                              </template>
                            </template>
                          </div>
                        </form>

                        <template v-if="exp.IS_VIEW_NEED_CONSIDER">
                          <div class="form-inline stl-mb-5">
                            <div class="form-group">
                              <label
                                >Необходимость корп. одобрения:&nbsp;
                              </label>
                              <select
                                v-if="exp.IS_SET_NEED_CONSIDER"
                                class="form-control"
                                v-model="exp.UF_IS_NEED_CONSIDER_NS"
                                :id="'need_consider_' + exp.ID"
                                v-on:change="
                                  saveFinanceIRR(
                                    exp.UF_IS_NEED_CONSIDER_NS,
                                    exp.EXPERTISE_ID,
                                    'UF_IS_NEED_CONSIDER_NS',
                                    'Необходимость корп. одобрения'
                                  )
                                "
                              >
                                <option value=""></option>
                                <option value="0">Нет</option>
                                <option value="1">Да</option>
                              </select>
                              <template v-else>
                                {{
                                  exp.UF_IS_NEED_CONSIDER_NS == 1 ? "Да" : "Нет"
                                }}
                              </template>
                            </div>
                          </div>
                        </template>

                        <form class="form-inline stl-mb-5">
                          <div class="form-group">
                            <label>Назначена До/После Одобрения ЭС: </label>
                            <select
                              :id="'expertise_set_time_' + exp.EXPERTISE_ID"
                              v-model="exp.UF_TIME_STATUS_CREATE_ID"
                              v-if="exp.IS_SET_TIME_CREATE_EXPERTISE"
                              class="form-control"
                              :disabled="false"
                              @change="
                                saveTimeStatusCreateExpertises(
                                  exp.EXPERTISE_ID,
                                  exp.UF_TIME_STATUS_CREATE_ID
                                )
                              "
                            >
                              <option
                                v-for="spTime in directory.sp_time_status_set_expertise"
                                v-if="spTime.CODE !== 'after_signing'"
                                :value="spTime.ID"
                                :key="spTime.ID"
                                >{{ spTime.NAME }}
                              </option>
                            </select>
                            <template
                              v-else-if="exp.UF_TIME_STATUS_CREATE_ID > 0"
                            >
                              <template
                                v-for="spTime in directory.sp_time_status_set_expertise"
                              >
                                <span
                                  v-if="
                                    spTime.ID == exp.UF_TIME_STATUS_CREATE_ID
                                  "
                                >
                                  {{ spTime.NAME }}
                                </span>
                              </template>
                            </template>
                          </div>
                        </form>

                        <template v-if="exp.IS_SET_FINANCIAL_IRR">
                          <div class="form-inline stl-mb-5">
                            <div class="form-group">
                              <label style="width: 150px;"
                                >IRR, проценты:&nbsp;</label
                              >
                              <vue-numeric
                                separator="space"
                                :precision="0"
                                v-bind:key="'irr_' + exp.ID"
                                type="text"
                                class="form-control i-wid-29"
                                v-model="exp.UF_IRR"
                                :max="100"
                                v-on:change.native="
                                  saveFinanceIRR(
                                    exp.UF_IRR,
                                    exp.EXPERTISE_ID,
                                    'UF_IRR',
                                    'IRR, проценты'
                                  )
                                "
                              />
                            </div>
                          </div>

                          <div class="form-inline stl-mb-5">
                            <div class="form-group">
                              <label style="width: 150px;"
                                >NPV, млн. рублей:&nbsp;</label
                              >
                              <vue-numeric
                                separator="space"
                                :precision="0"
                                v-bind:key="'npv_' + exp.ID"
                                type="text"
                                class="form-control i-wid-29"
                                v-model="exp.UF_NPV"
                                v-on:change.native="
                                  saveFinanceIRR(
                                    exp.UF_NPV,
                                    exp.EXPERTISE_ID,
                                    'UF_NPV',
                                    'NPV, млн. рублей'
                                  )
                                "
                              />
                            </div>
                          </div>

                          <div class="form-inline stl-mb-5">
                            <div class="form-group">
                              <label style="width: 150px;"
                                >WACC, проценты:&nbsp;</label
                              >
                              <vue-numeric
                                separator="space"
                                :precision="0"
                                v-bind:key="'npv_' + exp.ID"
                                type="text"
                                class="form-control i-wid-29"
                                v-model="exp.UF_WACC"
                                :max="100"
                                v-on:change.native="
                                  saveFinanceIRR(
                                    exp.UF_WACC,
                                    exp.EXPERTISE_ID,
                                    'UF_WACC',
                                    'WACC, проценты'
                                  )
                                "
                              />
                            </div>
                          </div>
                          <div class="form-inline stl-mb-5">
                            <div class="form-group">
                              <label style="width: 150px;"
                                >DPBP, лет:&nbsp;</label
                              >
                              <vue-numeric
                                separator="space"
                                :precision="0"
                                v-bind:key="'npv_' + exp.ID"
                                type="text"
                                class="form-control i-wid-29"
                                v-model="exp.UF_DPBP"
                                v-on:change.native="
                                  saveFinanceIRR(
                                    exp.UF_DPBP,
                                    exp.EXPERTISE_ID,
                                    'UF_DPBP',
                                    'DPBP, лет'
                                  )
                                "
                              />
                            </div>
                          </div>
                        </template>

                        <form
                          class="form-inline stl-mb-5"
                          v-if="
                            exp.IS_SET_TYPE_FIE_DZ &&
                              exp.IS_SET_TYPE_FIE_DZ == 1
                          "
                        >
                          <div class="form-group">
                            <label>Тип назначаемой экспертизы: </label>
                            <select
                              :id="'expertise_set_type_fie_' + exp.EXPERTISE_ID"
                              v-model="exp.UF_TYPE_FIE_ID"
                              v-if="exp.IS_SET_TYPE_FIE_DZ_EDIT"
                              class="form-control"
                              :disabled="false"
                              @change="
                                saveTypeFieExpertises(
                                  exp.EXPERTISE_ID,
                                  exp.UF_TYPE_FIE_ID
                                )
                              "
                            >
                              <option
                                v-for="spTime in directory.sp_expertise_type_fie"
                                v-if="
                                  exp.CODE === 'pte' && spTime.CODE === 'lizing'
                                    ? false
                                    : true
                                "
                                :value="spTime.ID"
                                :key="spTime.ID"
                                >{{ spTime.NAME }}
                              </option>
                            </select>
                            <template v-else>
                              <template
                                v-for="spTime in directory.sp_expertise_type_fie"
                              >
                                <span v-if="spTime.ID == exp.UF_TYPE_FIE_ID">
                                  {{ spTime.NAME }}
                                </span>
                              </template>
                            </template>
                          </div>
                        </form>
                        <form
                          class="form-inline stl-mb-5"
                          v-if="
                            exp.IS_SET_TYPE_FIE_DZ &&
                              exp.IS_SET_TYPE_FIE_DZ == 1 &&
                              isViewSconditionDZList.get(exp.EXPERTISE_ID)
                          "
                        >
                          <div class="form-group">
                            <label style="float: left;"
                              >Отлагательное условие:&nbsp;
                            </label>
                            <Multiselect
                              label="UF_NAME_RECORD"
                              v-if="exp.IS_SET_TYPE_FIE_DZ_EDIT"
                              class="i-main-style-rp i-main-style i-wid-50 stl-bs_bb multiselect-filter-project-register multiselect-multiline"
                              :limit="1"
                              :limitText="filterItemText"
                              track-by="ID"
                              v-model="exp.UF_SCONDITION_DZ_ID"
                              :options="item.SCONDITION_LIST"
                              :multiple="false"
                              placeholder=""
                              @input="
                                saveExpertiseSconditionDZ(
                                  exp.EXPERTISE_ID,
                                  exp.UF_SCONDITION_DZ_ID
                                )
                              "
                              style="width: 98%; min-width: 150px; min-height: 36px; margin-left: 228px; border: 1px solid #cecece"
                            />
                            <template v-else>
                              <template v-for="el in item.SCONDITION_LIST">
                                <template
                                  v-for="el2 in exp.UF_SCONDITION_DZ_ID"
                                >
                                  <span v-if="el.ID == el2.ID">
                                    {{ el2.UF_NAME_RECORD }}
                                  </span>
                                </template>
                              </template>
                            </template>
                          </div>
                        </form>

                        <form
                          class="form-inline stl-mb-5"
                          v-if="
                            exp.IS_SET_TYPE_PRE_DZ &&
                              exp.IS_SET_TYPE_PRE_DZ == 1
                          "
                        >
                          <div class="form-group">
                            <label>Тип назначаемой экспертизы: </label>
                            <select
                              :id="'expertise_set_type_pre_' + exp.EXPERTISE_ID"
                              v-model="exp.UF_TYPE_PRE_ID"
                              v-if="exp.IS_SET_TYPE_PRE_DZ_EDIT"
                              class="form-control"
                              :disabled="false"
                              @change="
                                saveTypePreExpertises(
                                  exp.EXPERTISE_ID,
                                  exp.UF_TYPE_PRE_ID
                                )
                              "
                            >
                              <option
                                v-for="spTime in directory.sp_expertise_type_pre"
                                :value="spTime.ID"
                                :key="spTime.ID"
                                >{{ spTime.NAME }}
                              </option>
                            </select>
                            <template v-else>
                              <template
                                v-for="spTime in directory.sp_expertise_type_pre"
                              >
                                <span v-if="spTime.ID == exp.UF_TYPE_PRE_ID">
                                  {{ spTime.NAME }}
                                </span>
                              </template>
                            </template>
                          </div>
                        </form>

                        <form
                          class="form-inline stl-mb-5"
                          v-if="exp.IS_VIEW_DOP_EXPERT"
                        >
                          <div class="form-group">
                            <label>Результат дополнительной экспертизы:</label>
                            <select
                              :id="'expertise_dop_' + exp.EXPERTISE_ID"
                              v-if="
                                (exp.IS_VIEW_BUTTON_END ||
                                  exp.IS_SET_RESULT_EXPERTISE) &&
                                  exp.UF_EXPERT_STATUS_DOP_ID == 131578
                              "
                              v-model="exp.UF_EXPERTISE_RESULT_DOP_ID"
                              class="form-control"
                              :disabled="!item.IS_ONLY_SET_DIRECTOR === 1"
                              @change="
                                saveResultExpertisesDop(
                                  exp.EXPERTISE_ID,
                                  exp.UF_EXPERTISE_RESULT_DOP_ID,
                                  item.RESULT_EXPERTISE_SP,
                                  'expertise_dop_' + exp.EXPERTISE_ID
                                )
                              "
                              :style="
                                'background:' +
                                  getCSSResult(
                                    item.RESULT_EXPERTISE_SP,
                                    exp.UF_EXPERTISE_RESULT_DOP_ID
                                  )
                              "
                            >
                              <option
                                v-for="expertiseResult in item.RESULT_EXPERTISE_SP"
                                v-if="
                                  (exp.IS_SET_NEW_RESULT_BY_SC == 1 &&
                                    expertiseResult.UF_IS_ONLY_SUSPENSIVE_CONDITION ===
                                      1) ||
                                    (exp.IS_SET_NEW_RESULT_BY_SC == 0 &&
                                      expertiseResult.UF_IS_ONLY_SUSPENSIVE_CONDITION !==
                                        1)
                                "
                                :style="
                                  `background-color: ${expertiseResult.UF_CSS_COLOR}`
                                "
                                :value="expertiseResult.ID"
                                :key="expertiseResult.ID"
                                >{{ expertiseResult.UF_NAME }}
                              </option>
                            </select>
                            <template
                              v-else-if="exp.UF_EXPERTISE_RESULT_DOP_ID"
                            >
                              <template
                                v-for="expertiseResult in item.RESULT_EXPERTISE_SP"
                              >
                                <strong
                                  v-if="
                                    expertiseResult.ID ===
                                      exp.UF_EXPERTISE_RESULT_DOP_ID
                                  "
                                  :style="
                                    `background-color: ${expertiseResult.UF_CSS_COLOR}`
                                  "
                                >
                                  {{
                                    getExpertiseResult(
                                      exp.UF_EXPERTISE_RESULT_DOP_ID,
                                      item.RESULT_EXPERTISE_SP
                                    )
                                  }}
                                </strong>
                              </template>
                            </template>
                          </div>
                        </form>
                        <form
                          class="form-inline stl-mb-5"
                          v-if="item.IS_SET_RISK_CLASS"
                        >
                          <div class="form-group">
                            <label>Риск-класс: &nbsp;</label>
                            <select
                              v-if="exp.IS_VIEW_BUTTON_END"
                              v-model="exp.UF_EXPERTISE_RISK_CLASS_ID"
                              class="form-control"
                              :disabled="!item.IS_ONLY_SET_DIRECTOR === 1"
                              @change="
                                saveRiskClassExpertises(
                                  exp.EXPERTISE_ID,
                                  exp.UF_EXPERTISE_RISK_CLASS_ID
                                )
                              "
                            >
                              <option
                                v-for="expertiseRickClass in item.RISK_CLASS_SP"
                                :value="expertiseRickClass.ID"
                                :key="expertiseRickClass.ID"
                                >{{ expertiseRickClass.UF_NAME }}
                              </option>
                            </select>
                            <strong v-else-if="exp.UF_EXPERTISE_RISK_CLASS_ID">
                              {{
                                getRiskClassExpertises(
                                  exp.UF_EXPERTISE_RISK_CLASS_ID,
                                  item.RISK_CLASS_SP
                                )
                              }}
                            </strong>
                          </div>
                        </form>
                        <form
                          class="form-inline"
                          v-if="item.IS_SET_DURATION_EXPERTISE"
                        >
                          <div class="form-group stl-mb-5">
                            <label>Вид проведения экспертизы: &nbsp;</label>
                            <template
                              v-if="
                                item.IS_ONLY_SET_DIRECTOR &&
                                  (isExpertiseEditable ||
                                    currentUser.IS_EXPERT_DIRETOR === 1) &&
                                  exp.IS_DIRECTOR_USER
                              "
                            >
                              <select
                                v-model="exp.UF_DURATION_EXPERTISE_ID"
                                class="form-control"
                                :disabled="!item.IS_ONLY_SET_DIRECTOR === 1"
                              >
                                <option
                                  v-for="durationExpertise in directory.sp_duration_expertise"
                                  :value="durationExpertise.ID"
                                  :key="durationExpertise.ID"
                                  >{{ durationExpertise.NAME }}
                                </option>
                              </select>
                              <button
                                v-if="
                                  item.IS_ONLY_SET_DIRECTOR ||
                                    isExpertiseEditable
                                "
                                type="button"
                                @click="
                                  saveDurationExpertise(
                                    exp.EXPERTISE_ID,
                                    exp.UF_DURATION_EXPERTISE_ID
                                  )
                                "
                                class="btn btn-default"
                              >
                                Применить
                              </button>
                            </template>
                            <strong v-else>
                              {{
                                getDurationExpertise(
                                  exp.UF_DURATION_EXPERTISE_ID
                                )
                              }}
                            </strong>
                          </div>
                        </form>
                        <!-- col-xs-12 col-sm-12 col-md-6 -->
                      </div>
                      <div class="col-xs-12 col-sm-8 col-md-6 col-lg-6">
                        <div class="form-group" v-if="item.IS_SET_COMMENT">
                          <div>
                            <label>{{
                              exp.IS_VIEW_DOP_EXPERT
                                ? "Комментарий основного эксперта"
                                : "Комментарий"
                            }}</label>
                            <textarea
                              v-if="exp.IS_SET_COMMENT && exp.IS_MAIN_EXPERTISE"
                              class="form-control stl-mb-10"
                              v-model="exp.UF_EXPERTISE_COMMENT"
                            ></textarea>
                            <button
                              v-if="exp.IS_SET_COMMENT && exp.IS_MAIN_EXPERTISE"
                              type="button"
                              class="btn btn-primary"
                              data-dismiss="modal"
                              @click="
                                saveCommentExpertises(
                                  exp.EXPERTISE_ID,
                                  exp.UF_EXPERTISE_COMMENT
                                )
                              "
                            >
                              Сохранить комментарий
                            </button>

                            <div
                              v-if="
                                !exp.IS_SET_COMMENT || !exp.IS_MAIN_EXPERTISE
                              "
                            >
                              {{ exp.UF_EXPERTISE_COMMENT }}
                            </div>
                          </div>
                          <div
                            v-if="exp.IS_VIEW_DOP_EXPERT"
                            style="padding-top: 10px;"
                          >
                            <label>Комментарий дополнительного эксперта</label>

                            <textarea
                              v-if="
                                exp.IS_SET_COMMENT &&
                                  exp.IS_VIEW_DOP_EXPERT &&
                                  exp.IS_SET_COMMENT_DOP
                              "
                              class="form-control stl-mb-10"
                              v-model="exp.UF_EXPERTISE_COMMENT_DOP"
                            ></textarea>
                            <button
                              v-if="
                                exp.IS_SET_COMMENT &&
                                  exp.IS_VIEW_DOP_EXPERT &&
                                  exp.IS_SET_COMMENT_DOP
                              "
                              type="button"
                              class="btn btn-primary"
                              data-dismiss="modal"
                              @click="
                                saveCommentExpertisesDop(
                                  exp.EXPERTISE_ID,
                                  exp.UF_EXPERTISE_COMMENT_DOP
                                )
                              "
                            >
                              Сохранить комментарий
                            </button>
                            <div
                              v-if="
                                !exp.IS_SET_COMMENT || !exp.IS_SET_COMMENT_DOP
                              "
                            >
                              {{ exp.UF_EXPERTISE_COMMENT_DOP }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- col-xs-12 col-sm-12 col-md-6 -->
                    </div>
                    <!-- row -->

                    <!-- блок загрузки и отображения документов -->
                    <div
                      class="container-fluid mycontainer-fluid content content_table stl-mb-5"
                      v-if="exp.IS_VIEW_DOWNLOAD_AREA"
                      style="padding:0; background: none;"
                    >
                      <table class="table">
                        <tbody>
                          <tr
                            v-bind:class="{
                              'document-file-delete':
                                exp.FILE_INFO['FILE'] !== null &&
                                exp.FILE_INFO['FILE']['UF_IS_DELETE'] == 1
                                  ? true
                                  : false
                            }"
                          >
                            <td
                              v-if="exp.IS_VIEW_DOWNLOAD_FILE_BUTTON"
                              style="width: 220px;"
                            >
                              <UploadExperFile
                                :exp="exp"
                                :docs="exp.FILE_INFO"
                                :sub-index="exp.FILE_INFO.TYPE_ID"
                              ></UploadExperFile>
                              <div else></div>
                            </td>
                            <td>
                              <a
                                v-if="
                                  exp.FILE_INFO['FILE'] !== null &&
                                    exp.FILE_INFO['FILE']['FILE']
                                "
                                :href="exp.FILE_INFO['FILE']['FILE']"
                                target="_blank"
                                style="display: inline-block; text-decoration: underline; color: #23527c"
                                class="doc-link"
                              >
                                {{ exp.FILE_INFO["NAME_TYPE"] }}
                              </a>
                              <span v-else>
                                <template
                                  v-if="exp.IS_DOWNLOAD_DOCUMENTS_NOT_REQ == 0"
                                >
                                  {{ exp.FILE_INFO["NAME_TYPE"] }}
                                </template>
                              </span>
                            </td>
                            <td>
                              <a
                                v-if="
                                  exp.FILE_INFO['FILE'] !== null &&
                                    exp.FILE_INFO['FILE']['COUNT_VERSION'] > 0
                                "
                                @click="
                                  getFileHistory(exp.FILE_INFO['FILE']['ID'])
                                "
                                style="display: inline-block; text-decoration: underline; color: #23527c"
                                class="doc-link"
                              >
                                {{ exp.FILE_INFO["FILE"]["COUNT_VERSION"] }}
                                (История)
                              </a>
                            </td>
                            <td>
                              <template
                                v-if="
                                  exp.FILE_INFO['FILE'] !== null &&
                                    exp.FILE_INFO['FILE']['UF_DATE_LOAD']
                                "
                              >
                                {{
                                  exp.FILE_INFO["FILE"]["UF_DATE_UPDATE"]
                                    ? exp.FILE_INFO["FILE"]["UF_DATE_UPDATE"]
                                    : exp.FILE_INFO["FILE"]["UF_DATE_LOAD"]
                                }}
                              </template>
                            </td>

                            <!-- ЭЦП галочка-->
                            <td
                              v-if="
                                exp.FILE_INFO['FILE'] !== null &&
                                  exp.FILE_INFO['FILE']['IS_DOWNLOAD']
                              "
                              class="tc-main"
                            >
                              <div
                                class="doc-Y"
                                v-if="
                                  exp.FILE_INFO['FILE']['UF_IS_SIGN_ECP'] == 1
                                "
                              ></div>
                              <div class="doc-N" v-else></div>
                            </td>
                            <td v-else></td>

                            <!-- ЭЦП Данные -->
                            <td style="white-space: nowrap;">
                              <div
                                class="esd-data"
                                v-if="
                                  exp.FILE_INFO['FILE'] !== null &&
                                    exp.FILE_INFO['FILE']['IS_DOWNLOAD'] &&
                                    exp.FILE_INFO['IS_ECP_REQ']
                                "
                              >
                                <i
                                  class="esd-data esd_icon"
                                  @click="
                                    getECPInfo(exp.FILE_INFO['FILE']['ID'])
                                  "
                                  style="margin-right: 25px"
                                >
                                  ЭЦП
                                  <img src="/images/i-eds.png" />
                                </i>
                                <div
                                  class="esd-data__info esd-data__info-popup"
                                  v-show="
                                    resultECP[exp.FILE_INFO['FILE']['ID']]
                                  "
                                >
                                  <div
                                    class="esd-close"
                                    @click="
                                      closeECP(exp.FILE_INFO['FILE']['ID'])
                                    "
                                  >
                                    <i class="esd_exit"></i>
                                  </div>
                                  <div
                                    v-if="
                                      resultECP[exp.FILE_INFO['FILE']['ID']]
                                    "
                                  >
                                    <p class="text-center">
                                      Подлинник электронного документа,
                                      подписанного ЭЦП,
                                      <br />хранится в информационной системе
                                      “Личный кабинет заемщика” <br />Фонда
                                      развития промышленности
                                    </p>
                                    <h3 class="esd-title">
                                      Сведения о сертификате ЭП
                                    </h3>
                                    <div class="container-fluid">
                                      <div class="row">
                                        <div
                                          class="col-xs-4 col-md-4 stl-col-pb-8"
                                        >
                                          Сертификат:
                                        </div>
                                        <div
                                          class="col-xs-8 col-md-8 stl-col-pb-8 esd_wsn esd_wsn"
                                        >
                                          {{ result.SERTIFICATE_NUMBER }}
                                        </div>
                                      </div>
                                      <div class="row">
                                        <div
                                          class="col-xs-4 col-md-4 stl-col-pb-8"
                                        >
                                          Кем выдан:
                                        </div>
                                        <div
                                          class="col-xs-8 col-md-8 stl-col-pb-8 esd_wsn"
                                        >
                                          {{ result.ISSUER }}
                                        </div>
                                      </div>
                                      <div class="row">
                                        <div
                                          class="col-xs-4 col-md-4 stl-col-pb-8"
                                        >
                                          Организация:
                                        </div>
                                        <div
                                          class="col-xs-8 col-md-8 stl-col-pb-8 esd_wsn"
                                        >
                                          {{ result.COMPANY }}
                                        </div>
                                      </div>
                                      <div class="row">
                                        <div
                                          class="col-xs-4 col-md-4 stl-col-pb-8"
                                        >
                                          Кому выдан:
                                        </div>
                                        <div
                                          class="col-xs-8 col-md-8 stl-col-pb-8 esd_wsn"
                                        >
                                          {{ result.OWNER_FIO }}
                                        </div>
                                      </div>
                                      <div class="row">
                                        <div
                                          class="col-xs-4 col-md-4 stl-col-pb-8"
                                        >
                                          Действителен:
                                        </div>
                                        <div
                                          class="col-xs-8 col-md-8 stl-col-pb-8 esd_wsn"
                                        >
                                          {{ result.DATE_USE_SERTIFICATE }}
                                        </div>
                                      </div>
                                      <div class="row">
                                        <div
                                          class="col-xs-4 col-md-4 stl-col-pb-8"
                                        >
                                          Название документа:
                                        </div>
                                        <div
                                          class="col-xs-8 col-md-8 stl-col-pb-8 esd_wsn"
                                        >
                                          {{ result.FILE_NAME }}
                                        </div>
                                      </div>
                                      <div class="row">
                                        <div
                                          class="col-xs-4 col-md-4 stl-col-pb-8"
                                        >
                                          Дата загрузки:
                                        </div>
                                        <div
                                          class="col-xs-8 col-md-8 stl-col-pb-8 esd_wsn"
                                        >
                                          {{ result.FILE_DATE_LOAD }}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </td>
                            <!-- Подписант -->

                            <!-- Подписант -->
                            <td>
                              <template
                                v-if="
                                  exp.FILE_INFO['FILE'] !== null &&
                                    exp.FILE_INFO['FILE']['IS_DOWNLOAD']
                                "
                              >
                                <a
                                  v-for="item in exp.FILE_INFO[
                                    'ECP_GET_MANAGER_LIST'
                                  ]"
                                  v-if="
                                    item.ACTIVE_CODE ===
                                      currentUser.ACTIVE_ROLE_CODE
                                  "
                                  @click="
                                    getLinkFileECP(
                                      exp.FILE_INFO['FILE']['ID'],
                                      'txt'
                                    )
                                  "
                                >
                                  <img src="/images/ecp/txt.png" />
                                </a>

                                <a
                                  v-for="item in exp.FILE_INFO[
                                    'ECP_GET_MANAGER_LIST'
                                  ]"
                                  v-if="
                                    item.ACTIVE_CODE ===
                                      currentUser.ACTIVE_ROLE_CODE
                                  "
                                  @click="
                                    getLinkFileECP(
                                      exp.FILE_INFO['FILE']['ID'],
                                      'sig'
                                    )
                                  "
                                >
                                  <img src="/images/ecp/sig.png" />
                                </a>

                                {{
                                  exp.FILE_INFO["FILE"]["UF_FILE_SIGN_AUTHOR"]
                                }}
                              </template>
                            </td>
                            <!-- Соответствие документа -->
                            <td v-if="exp.IS_VIEW_DOWNLOAD_FILE_BUTTON">
                              <a
                                v-show="
                                  exp.FILE_INFO['FILE'] !== null &&
                                    exp.FILE_INFO['FILE']['IS_DOWNLOAD'] &&
                                    exp.FILE_INFO['FILE']['UF_IS_AKCEPT'] !=
                                      1 &&
                                    exp.FILE_INFO['FILE']['UF_IS_DELETE'] !=
                                      1 /*&&
                           ( (currentUser.TYPE_USER === 'manager' &&
                             docInfo.IS_LOAD_FILE_MANAGER &&
                             checkUploadManager(docInfo)))*/
                                "
                                @click="deleteFile(exp.FILE_INFO['FILE']['ID'])"
                                class="link-delete-row"
                                style="margin: 0 10px;"
                              ></a>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div
                      v-if="exp.IS_VIEW_BUTTON_END"
                      style="padding-bottom: 10px; margin-bottom: 10px; border-bottom: 1px dotted #cecece"
                    >
                      <button
                        v-if="exp.IS_NOT_SET_EXPERT == 1"
                        type="button"
                        @click="saveEndMainDocESExpertise(exp.EXPERTISE_ID)"
                        class="btn btn-default"
                      >
                        Завершить экспертизу
                      </button>
                      <button
                        v-else
                        type="button"
                        @click="saveEndMainDocESExpertise(exp.EXPERTISE_ID)"
                        :disabled="exp.UF_EXPERT_ID == 0 ? true : false"
                        class="btn btn-default"
                      >
                        Завершить экспертизу
                      </button>

                      <button
                        v-if="exp.IS_VIEW_BUTTON_END_DOP"
                        type="button"
                        @click="saveEndMainDocESExpertiseDop(exp.EXPERTISE_ID)"
                        class="btn btn-default"
                      >
                        Завершить дополнительную экспертизу
                      </button>
                    </div>
                    <form
                      class="form-inline"
                      v-if="
                        (exp.UF_EXPERT_ID !== 0 &&
                          showExpertSelector &&
                          currentUser.IS_EXPERT_DIRETOR === 1 &&
                          exp.IS_DIRECTOR_USER) ||
                          (currentUser.IS_EXPERT_DIRETOR === 1 &&
                            exp.IS_DIRECTOR_USER &&
                            exp.UF_EXPERT_ID === 0) ||
                          (exp.CODE == 'pte' &&
                            currentUser.ACTIVE_ROLE_CODE === 'admin')
                      "
                    >
                      <div class="form-group">
                        <label>Эксперт: &nbsp;</label>
                        <select
                          v-model="item.NEW_EXPERT_ID"
                          class="form-control"
                          :disabled="!item.IS_ONLY_SET_DIRECTOR === 1"
                        >
                          <option
                            v-for="expert in experts[item.ID_TYPE_EXPERTISE]"
                            :value="expert.ID"
                            :key="expert.ID"
                            >{{ expert.NAME }}
                          </option>
                        </select>
                      </div>
                      &nbsp;
                      <button
                        type="button"
                        @click="addExpert(item.NEW_EXPERT_ID, exp.EXPERTISE_ID)"
                        class="btn btn-default"
                      >
                        {{
                          exp.UF_EXPERT_ID > 0
                            ? "Изменить эксперта"
                            : "Назначить эксперта"
                        }}
                      </button>
                    </form>
                    <button
                      v-if="
                        exp.UF_EXPERT_STATUS_ID === 131578 &&
                          currentUser.IS_EXPERT_DIRETOR === 1 &&
                          exp.UF_EXPERT_ID &&
                          exp.IS_DIRECTOR_USER &&
                          !exp.UF_DATE_END_EXPERT
                      "
                      type="button"
                      @click="expertHandler"
                      class="btn btn-primary"
                      style="margin-top: 20px"
                    >
                      {{
                        exp.UF_EXPERT_ID > 0
                          ? "Сменить ответственного"
                          : "Назначить ответственного"
                      }}
                    </button>

                    <!-- Заключение Минпромторг -->
                    <div v-if="exp.IS_MPT_EXPERTISE" class="modal-body">
                      <p
                        style="border-bottom: 1px solid #cecece; text-transform: uppercase;"
                      >
                        <strong>Заключение Минпроторга</strong>
                      </p>

                      <label>
                        <input
                          type="checkbox"
                          v-model="exp.ZAKLUCHENIE_MPT.UF_IS_MPT"
                          :disabled="exp.ZAKLUCHENIE_MPT.UF_IS_MPT === 1"
                        />
                        Запрос направлен
                        {{ exp.ZAKLUCHENIE_MPT.UF_DATE_MPT }}</label
                      >
                      <div class="form-group">
                        <label>Департамент</label>
                        <select
                          class="form-control"
                          v-model="exp.ZAKLUCHENIE_MPT.UF_DEPARTAMENT_ID"
                          :disabled="
                            !exp.ZAKLUCHENIE_MPT.IS_CHANGE_DEPARTAMENT ||
                              !exp.IS_MPT_ZAKLUCHENIE_EDIT
                          "
                        >
                          <option
                            v-for="item in directory.departaments"
                            :value="item.ID"
                            >{{ item.NAME }}
                          </option>
                        </select>
                      </div>
                      <div class="form-group">
                        <label>Комментарий</label>
                        <textarea
                          v-model="exp.ZAKLUCHENIE_MPT.UF_COMMENT_MPT"
                          :disabled="!exp.IS_MPT_ZAKLUCHENIE_EDIT"
                          class="form-control"
                        ></textarea>
                      </div>
                      <button
                        v-if="exp.IS_MPT_ZAKLUCHENIE_EDIT"
                        type="button"
                        @click="saveMPT(exp.ZAKLUCHENIE_MPT)"
                        class="btn btn-info"
                      >
                        Сохранить
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-if="
                  item.EXPERTISE_LIST.length === 0 || item.IS_MILTY_EXPERT === 1
                "
              >
                <div
                  v-if="
                    expChecked[index] &&
                      experts !== null &&
                      experts[item.ID_TYPE_EXPERTISE]
                  "
                >
                  <form
                    class="form-inline"
                    v-if="
                      isExpertiseEditable && currentUser.IS_EXPERT_DIRETOR !== 1
                    "
                  >
                    <div class="form-group" v-if="!item.IS_ONLY_SET_DIRECTOR">
                      <label>Эксперт: &nbsp;</label>
                      <select
                        v-model="item.NEW_EXPERT_ID"
                        class="form-control form-control-xl form-control-m"
                        :disabled="!isExpertiseEditable"
                      >
                        <option
                          v-for="expert in experts[item.ID_TYPE_EXPERTISE]"
                          :value="expert.ID"
                          :key="expert.ID"
                          >{{ expert.NAME }}
                        </option>
                      </select>
                    </div>
                    <div
                      class="form-group"
                      v-if="
                        item.IS_SET_VARIANT_DOP_EXPERTISE === 1 &&
                          item.IS_ONLY_SET_DIRECTOR === 1
                      "
                    >
                      <label>Вариант проведения экспертизы: &nbsp;</label>
                      <select
                        v-model="item.UF_VARIANT_DOP_EXPERTISE_ID"
                        class="form-control form-control-m"
                        :disabled="!isExpertiseEditable"
                      >
                        <option
                          class="form-control-m"
                          v-for="itemType in DtypeZalogExpertise"
                          :value="itemType.ID"
                          :key="itemType.ID"
                          >{{ itemType.NAME }}
                        </option>
                      </select>
                    </div>

                    <div
                      class="form-group"
                      v-if="
                        item.IS_SET_DURATION_EXPERTISE === 1 &&
                          item.IS_ONLY_SET_DIRECTOR === 1
                      "
                    >
                      <label>Вид проведения экспертизы: &nbsp;</label>
                      <select
                        v-model="item.UF_DURATION_EXPERTISE_ID"
                        class="form-control form-control-m"
                        :disabled="!isExpertiseEditable"
                      >
                        <option
                          class="form-control-m"
                          v-for="durationExpertise in directory.sp_duration_expertise"
                          :value="durationExpertise.ID"
                          :key="durationExpertise.ID"
                          >{{ durationExpertise.NAME }}
                        </option>
                      </select>
                    </div>

                    &nbsp;
                    <button
                      type="button"
                      @click="
                        addExpertise(
                          item.UF_VARIANT_DOP_EXPERTISE_ID,
                          item.UF_DURATION_EXPERTISE_ID,
                          item.ID_TYPE_EXPERTISE,
                          item.VID_EXPERTISE,
                          item.TYPE_PROVISION,
                          item.NEW_EXPERT_ID
                        )
                      "
                      class="btn btn-default"
                    >
                      Назначить экспертизу
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>

          <div
            class="col-md-3"
            v-if="
              currentUser.ACTIVE_ROLE_CODE === 'manager2' ||
                currentUser.ACTIVE_ROLE_CODE === 'manager3'
            "
          >
            <label>Комментарий по текущему статусу проекта</label>
            <textarea
              @change="updateExpertiseComment()"
              class="form-control"
              maxlength="150"
              v-model="project.UF_COMMENT_STATUS_M"
              :disabled="!isExpertiseEditable"
            ></textarea>
            макс число символов - 150
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade in show"
      v-if="showDocHistoryDialog"
      tabindex="-1"
      role="dialog"
    >
      <div
        style="width: 1150px;z-index: 10000"
        class="modal-dialog"
        role="document"
      >
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              v-on:click="showDocHistoryDialog = false"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">История изменения статуса документа</h4>
          </div>
          <div
            class="modal-body"
            style="
    overflow: scroll;
    max-height: 800px;
"
          >
            <table class="table table-hover">
              <thead>
                <tr>
                  <th>Версия документа</th>
                  <th>Документ</th>
                  <th>Дата загрузки документа</th>
                  <th></th>
                  <th>ЭЦП</th>
                  <th>Подписант</th>
                  <th>Дата действия</th>
                  <th>Сотрудник</th>
                  <th>Тип действия</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="item in documentHistory"
                  v-bind:class="{
                    'document-file-delete': item.UF_IS_DELETE
                  }"
                >
                  <td>{{ item.VERSION }}</td>
                  <td>
                    <a
                      :href="siteUrl + item.FILE"
                      class="doc-link"
                      target="blank"
                      >{{ getFileName(item.FILE) }}</a
                    >
                  </td>
                  <td>{{ item.UF_DATE_UPDATE }}</td>
                  <!-- эцп -->
                  <td style="white-space: nowrap;" v-if="item.IS_SET_ECP">
                    <div class="doc-Y" v-if="item.UF_IS_SIGN_ECP"></div>
                    <div class="doc-N" v-else></div>
                  </td>
                  <td v-else></td>
                  <!-- modal ECP -->
                  <td
                    style="white-space: nowrap; text-decoration-line: none !important"
                    v-if="item.IS_SET_ECP"
                  >
                    <i
                      class="esd-data esd_icon"
                      @click="getECPHistoryInfo(item.ID)"
                      style="margin-right: 25px"
                    >
                      ЭЦП
                      <img src="/images/i-eds.png" />
                    </i>
                    <div class="esd-data">
                      <div
                        class="esd-data__info_history"
                        v-show="resultECP[item.ID]"
                      >
                        <div class="esd-close" @click="closeECP(item.ID)">
                          <i class="esd_exit"></i>
                        </div>
                        <div v-if="resultECP[item.ID]">
                          <p class="text-center">
                            Подлинник электронного документа, подписанного ЭЦП,
                            <br />хранится в информационной системе “Личный
                            кабинет заемщика” <br />Фонда развития
                            промышленности
                          </p>
                          <h3 class="esd-title">
                            Сведения о сертификате ЭП
                          </h3>
                          <div class="container-fluid">
                            <div class="row">
                              <div class="col-xs-4 col-md-4 stl-col-pb-8">
                                Сертификат:
                              </div>
                              <div
                                class="col-xs-8 col-md-8 stl-col-pb-8 esd_wsn esd_wsn"
                              >
                                {{ result[item.ID].SERTIFICATE_NUMBER }}
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-xs-4 col-md-4 stl-col-pb-8">
                                Кем выдан:
                              </div>
                              <div
                                class="col-xs-8 col-md-8 stl-col-pb-8 esd_wsn"
                              >
                                {{ result[item.ID].ISSUER }}
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-xs-4 col-md-4 stl-col-pb-8">
                                Организация:
                              </div>
                              <div
                                class="col-xs-8 col-md-8 stl-col-pb-8 esd_wsn"
                              >
                                {{ result[item.ID].COMPANY }}
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-xs-4 col-md-4 stl-col-pb-8">
                                Кому выдан:
                              </div>
                              <div
                                class="col-xs-8 col-md-8 stl-col-pb-8 esd_wsn"
                              >
                                {{ result[item.ID].OWNER_FIO }}
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-xs-4 col-md-4 stl-col-pb-8">
                                Действителен:
                              </div>
                              <div
                                class="col-xs-8 col-md-8 stl-col-pb-8 esd_wsn"
                              >
                                {{ result[item.ID].DATE_USE_SERTIFICATE }}
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-xs-4 col-md-4 stl-col-pb-8">
                                Название документа:
                              </div>
                              <div
                                class="col-xs-8 col-md-8 stl-col-pb-8 esd_wsn"
                              >
                                {{ result[item.ID].FILE_NAME }}
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-xs-4 col-md-4 stl-col-pb-8">
                                Дата загрузки:
                              </div>
                              <div
                                class="col-xs-8 col-md-8 stl-col-pb-8 esd_wsn"
                              >
                                {{ result[item.ID].FILE_DATE_LOAD }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </td>
                  <td v-else></td>
                  <td style="white-space: nowrap;" v-if="item.IS_SET_ECP">
                    <div>
                      {{ item.UF_FILE_SIGN_AUTHOR }}
                    </div>
                  </td>
                  <td v-else></td>
                  <td>{{ item.UF_DATE_AKCEPT }}</td>
                  <td>{{ item.UF_MANAGER_AKCEPT_NAME }}</td>
                  <td>{{ item.UF_IS_AKCEPT }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-default"
              data-dismiss="modal"
              v-on:click="showDocHistoryDialog = false"
            >
              Закрыть
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <project-menu></project-menu>
    <!-- /.modal -->
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import { FETCH_PROJECT, FETCH_DIRECTORY } from "@/store/actions.type";
import ProjectHeader from "@/components/project/partial/ProjectHeader";
import { ExpertiseService, ProjectsService } from "@/common/api.service";
import { FETCH_EXPERTISES } from "@/store/actions.type";
import { AUTH_URL } from "@/common/config";
import UploadExperFile from "./documents/UploadExperFile";
import ProjectMenu from "@/components/project/partial/ProjectMenu";
import Multiselect from "vue-multiselect";

export default {
  name: "ExpertStatus",
  title: "Статус экспертиз проекта",
  data() {
    return {
      showExpertSelector: false,
      expertLoaded: false,
      experts: null,
      siteUrl: "",
      expChecked: null,
      isExpertiseEditable: false,
      isExpertiseView: false,
      type_provision_sp: "",
      isLoadingComponent: false,
      resultECP: {},
      result: "",
      showDocHistoryDialog: false,
      documentHistory: [],
      MPTData: {
        UF_IS_MPT: 0,
        UF_DEPARTAMENT_ID: 0,
        IS_CHANGE_DEPARTAMENT: 1,
        UF_COMMENT_MPT: ""
      },
      isViewSconditionDZList: []
      // tosterErrors: [],
    };
  },
  watch: {},
  components: {
    ProjectMenu,
    ProjectHeader,
    UploadExperFile,
    Multiselect
  },
  computed: {
    ...mapGetters([
      "project",
      "isLoading",
      "directory",
      "currentUser",
      "expertise",
      "DTypeProvision",
      "DtypeZalogExpertise"
    ])
  },
  methods: {
    async fetchProject() {
      await this.$store.dispatch(FETCH_PROJECT, this.$route.params.id);
      await ProjectsService.getRulesChangeStatusUser(
        this.project.UF_STATUS_ID
      ).then(({ data }) => {
        this.isExpertiseEditable = data.IS_EDIT_PANEL_EXPERTISE;
        this.isExpertiseView = data.IS_VIEW_PANEL_EXPERTISE;
      }, this);
      await this.fetchExpertise();
      await this.fetchMPT();
      this.isLoadingComponent = true;
    },

    async fetchExpertise() {
      await this.$store.dispatch(FETCH_EXPERTISES, this.$route.params.id);
      if (this.expChecked === null) {
        this.expChecked = [];
        Object.keys(this.expertise).map(function(e) {
          console.log(this.expertise[e].EXPERTISE_ADDED);
          Vue.set(this.expChecked, e, this.expertise[e].EXPERTISE_ADDED);
        }, this);
      }
      if (this.experts === null) {
        this.experts = {};
        await Object.keys(this.expertise).map(function(e) {
          Vue.set(this.experts, this.expertise[e].ID_TYPE_EXPERTISE, []);
        }, this);
        await Object.keys(this.expertise).map(async function(e) {
          let experts = await this.expertList(
            this.expertise[e].ID_TYPE_EXPERTISE,
            this.expertise[e].VID_EXPERTISE
          );
          Vue.set(this.experts, this.expertise[e].ID_TYPE_EXPERTISE, experts);
        }, this);
      }

      this.isViewSconditionDZList = new Map();
      Object.keys(this.expertise).map(function(e) {
        if (this.expertise[e].IS_SET_TYPE_FIE_DZ == 1) {
          let idTemp = this.directory.sp_expertise_type_fie.filter(
            c => c.CODE == "suspensive_condition"
          );

          for (let key in this.expertise[e].EXPERTISE_LIST) {
            let flag = false;
            if (
              this.expertise[e].EXPERTISE_LIST[key].UF_TYPE_FIE_ID ==
              idTemp[0].ID
            ) {
              flag = true;
            }
            this.isViewSconditionDZList.set(
              this.expertise[e].EXPERTISE_LIST[key].EXPERTISE_ID,
              flag
            );
            Vue.set(
              this.isViewSconditionDZList,
              this.expertise[e].EXPERTISE_LIST[key].EXPERTISE_ID,
              flag
            );
          }
        }
      }, this);
    },
    async fetchMPT() {
      ProjectsService.getZakluchenieMinProm(this.$route.params.id).then(
        ({ data }) => {
          this.MPTData = data;
        }
      );
    },

    saveMPT(zakluchenieMPT) {
      zakluchenieMPT.UF_IS_MPT = 1;
      ProjectsService.editZakluchenieMinPromByExpertise(
        this.$route.params.id,
        zakluchenieMPT
      ).then(({ data }) => {
        //this.fetchMPT();
        if (!data.error) {
          this.$toasted.show(
            "Информация о заключении  Минпроторга успешно сохранена",
            {
              theme: "green",
              position: "bottom-right",
              duration: 3500
            }
          );
          //this.fetchExpertise();ё
        } else {
          data.errorArr.forEach(function(text) {
            this.$toasted.show(text, {
              theme: "red",
              position: "bottom-right",
              duration: 3500
            });
          }, this);
        }
      }, this);

      /*this.MPTData.UF_IS_MPT = 1;
      ProjectsService.editZakluchenieMinProm(
        this.$route.params.id,
        this.MPTData
      ).then(() => {
        this.fetchMPT();
      }, this);*/
    },
    expertList: async function(id, vidId) {
      return ExpertiseService.getListExpertMainDocESExpertise(
        id,
        vidId,
        this.project.ID
      ).then(({ data }) => data);
    },
    expertHandler() {
      this.showExpertSelector = !this.showExpertSelector;
    },
    getExpert: function(id, expertId) {
      let t = this.experts[id].filter(c => c.ID === expertId);
      if (t.length > 0) {
        return t[0].NAME;
      }
      return "";
    },
    getExpertiseStatusName: function(id) {
      let t = this.directory.status_expertise.filter(c => c.ID === id);
      if (t.length > 0) {
        return t[0].NAME;
      }
      return "";
    },
    // добавил тип обеспечения
    getTypeZalogExpertis: function(id) {
      let t = this.directory.sp_variant_zalog_expertise.filter(
        c => c.ID === id
      );
      if (t.length > 0) {
        return t[0].NAME;
      }
      return "";
    },
    getExpertiseStatusCode: function(id) {
      let t = this.directory.status_expertise.filter(c => c.ID === id);
      if (t.length > 0) {
        return t[0].CODE;
      }
      return "";
    },

    getDurationExpertise: function(id) {
      let t = this.directory.sp_duration_expertise.filter(c => c.ID === id);
      if (t.length > 0) {
        return t[0].NAME;
      }
      return "";
    },
    getExpertiseResult: function(id, itemResultExpertises) {
      let t = itemResultExpertises.filter(c => c.ID === id);
      if (t.length > 0) {
        return t[0].UF_NAME;
      }
      return "";
    },
    getRiskClassExpertises: function(id, itemRiskClassExpertises) {
      console.log("itemRiskClassExpertises", itemRiskClassExpertises);
      let t = itemRiskClassExpertises.find(c => c.ID === id);
      if (t.UF_NAME !== "") {
        return t.UF_NAME;
      }
      return "";
    },
    addExpertise(
      dopExpertiseId,
      durationExpertiseId,
      typeId,
      vidId,
      typeProvisionId,
      expertId
    ) {
      ExpertiseService.addMainDocESExpertise(this.$route.params.id, {
        UF_VARIANT_DOP_EXPERTISE_ID: dopExpertiseId,
        UF_DURATION_EXPERTISE_ID: durationExpertiseId,
        UF_EXPERTISE_TYPE_ID: typeId,
        UF_EXPERTISE_VID_ID: vidId,
        UF_TYPE_PROVISION_ID: typeProvisionId,
        UF_EXPERT_ID: expertId
      }).then(({ data }) => {
        if (!data.error) {
          this.fetchExpertise();
          this.$toasted.show("Экспертиза создана", {
            theme: "green",
            position: "bottom-right",
            duration: 3500
          });
        } else {
          data.errorArr.forEach(function(text) {
            this.$toasted.show(text, {
              theme: "red",
              position: "bottom-right",
              duration: 3500
            });
          }, this);
        }
      }, this);
    },
    // после выбора эксперта отправляем POST запрос
    addExpert(expertId, idExpertise) {
      ExpertiseService.addMainDocESExpertiseExpert(
        this.$route.params.id,
        idExpertise,
        {
          UF_EXPERT_ID: expertId
        }
      ).then(({ data }) => {
        if (!data.error) {
          this.fetchExpertise();
        }
      }, this);
      this.expertHandler();
    },
    saveDurationExpertise(idExpertise, durationExpertiseId) {
      ExpertiseService.saveDurationExpertise(
        this.$route.params.id,
        idExpertise,
        {
          UF_DURATION_EXPERTISE_ID: durationExpertiseId
        }
      ).then(({ data }) => {
        if (!data.error) {
          this.fetchExpertise();
          this.$toasted.show("Вид проведения экспертизы изменен", {
            theme: "green",
            position: "bottom-right",
            duration: 3500
          });
        } else {
          data.errorArr.forEach(function(text) {
            this.$toasted.show(text, {
              theme: "red",
              position: "bottom-right",
              duration: 3500
            });
          }, this);
        }
      }, this);
    },
    saveRiskClassExpertises(idExpertise, expertiseRickClassId) {
      ExpertiseService.saveRiskClassExpertises(
        this.$route.params.id,
        idExpertise,
        {
          UF_EXPERTISE_RISK_CLASS_ID: expertiseRickClassId
        }
      ).then(({ data }) => {
        if (!data.error) {
          this.fetchExpertise();
        }
        if (data.error) {
          data.errorAr.forEach(function(text) {
            this.$toasted.show(text.TEXT, {
              theme: "red",
              position: "bottom-right",
              duration: 3500
            });
          }, this);
        }
        this.$toasted.show("Риск-класс экспертизы успешно изменен", {
          theme: "green",
          position: "bottom-right",
          duration: 3000
        });
      }, this);
    },
    saveResultExpertises(idExpertise, expertiseResultId, spResult, id) {
      //установить
      let elem = document.getElementById(id);
      elem.style.background = this.getCSSResult(spResult, expertiseResultId);

      ExpertiseService.saveResultExpertises(
        this.$route.params.id,
        idExpertise,
        {
          UF_EXPERTISE_RESULT_ID: expertiseResultId
        }
      ).then(({ data }) => {
        if (!data.error) {
          this.$toasted.show("Результат экспертизы успешно изменен", {
            theme: "green",
            position: "bottom-right",
            duration: 3000
          });
          this.fetchExpertise();
        }
        if (data.error) {
          data.errorAr.forEach(function(text) {
            this.$toasted.show(text, {
              theme: "red",
              position: "bottom-right",
              duration: 3500
            });
          }, this);
        }
      }, this);
    },
    saveResultExpertisesDop(idExpertise, expertiseResultId, spResult, id) {
      //установить
      let elem = document.getElementById(id);
      elem.style.background = this.getCSSResult(spResult, expertiseResultId);

      ExpertiseService.saveResultExpertisesDop(
        this.$route.params.id,
        idExpertise,
        {
          UF_EXPERTISE_RESULT_DOP_ID: expertiseResultId
        }
      ).then(({ data }) => {
        if (!data.error) {
          this.$toasted.show(
            "Результат дополнительной экспертизы успешно изменен",
            {
              theme: "green",
              position: "bottom-right",
              duration: 3000
            }
          );
          this.fetchExpertise();
        }
        if (data.error) {
          data.errorAr.forEach(function(text) {
            this.$toasted.show(text, {
              theme: "red",
              position: "bottom-right",
              duration: 3500
            });
          }, this);
        }
      }, this);
    },
    saveTimeStatusCreateExpertises(idExpertise, expertiseSetTimeStatusId) {
      //установить
      ExpertiseService.saveTimeStatusCreateExpertises(
        this.$route.params.id,
        idExpertise,
        {
          UF_TIME_STATUS_CREATE_ID: expertiseSetTimeStatusId
        }
      ).then(({ data }) => {
        if (!data.error) {
          this.$toasted.show(
            'Поле "Назначена До/После Одобрения ЭС" успешно изменено',
            {
              theme: "green",
              position: "bottom-right",
              duration: 3000
            }
          );
          this.fetchExpertise();
        }
        if (data.error) {
          data.errorArr.forEach(function(text) {
            this.$toasted.show(text, {
              theme: "red",
              position: "bottom-right",
              duration: 3500
            });
          }, this);
        }
      }, this);
    },
    saveTypeFieExpertises(idExpertise, expertiseTypeFieId) {
      //установить
      ExpertiseService.saveExpertiseTypeFIEDZ(
        this.$route.params.id,
        idExpertise,
        {
          UF_TYPE_FIE_ID: expertiseTypeFieId
        }
      ).then(({ data }) => {
        if (!data.error) {
          this.$toasted.show(
            'Поле "Тип назначаемой экспертизы" успешно изменено',
            {
              theme: "green",
              position: "bottom-right",
              duration: 3000
            }
          );
          this.fetchExpertise();

          let idTemp = this.directory.sp_expertise_type_fie.filter(
            c => c.ID === expertiseTypeFieId && c.CODE == "suspensive_condition"
          );
          let flag = idTemp.length && idTemp[0].ID > 0 ? true : false;
          this.isViewSconditionDZList.set(idExpertise, flag);
        }
        if (data.error) {
          data.errorArr.forEach(function(text) {
            this.$toasted.show(text, {
              theme: "red",
              position: "bottom-right",
              duration: 3500
            });
          }, this);
        }
      }, this);
    },

    saveExpertiseSconditionDZ(idExpertise, expertiseSconditionDZId) {
      //установить
      ExpertiseService.saveExpertiseSconditionDZ(
        this.$route.params.id,
        idExpertise,
        {
          UF_SCONDITION_DZ_ID: expertiseSconditionDZId
        }
      ).then(({ data }) => {
        if (!data.error) {
          this.$toasted.show('Поле "Отлагательное условие" успешно изменено', {
            theme: "green",
            position: "bottom-right",
            duration: 3000
          });
          this.fetchExpertise();
        }
        if (data.error) {
          data.errorArr.forEach(function(text) {
            this.$toasted.show(text, {
              theme: "red",
              position: "bottom-right",
              duration: 3500
            });
          }, this);
        }
      }, this);
    },

    saveTypePreExpertises(idExpertise, expertiseTypePreId) {
      //установить
      ExpertiseService.saveExpertiseTypePREDZ(
        this.$route.params.id,
        idExpertise,
        {
          UF_TYPE_PRE_ID: expertiseTypePreId
        }
      ).then(({ data }) => {
        if (!data.error) {
          this.$toasted.show(
            'Поле "Тип назначаемой экспертизы" успешно изменено',
            {
              theme: "green",
              position: "bottom-right",
              duration: 3000
            }
          );
          this.fetchExpertise();
        }
        if (data.error) {
          data.errorArr.forEach(function(text) {
            this.$toasted.show(text, {
              theme: "red",
              position: "bottom-right",
              duration: 3500
            });
          }, this);
        }
      }, this);
    },

    getCSSResult(spResult, expertiseResultId) {
      //установить
      let t = spResult.find(c => c.ID === expertiseResultId);
      if (t != undefined && t.UF_CSS_COLOR !== "") {
        return t.UF_CSS_COLOR;
      }
      return "";
    },
    saveEndMainDocESExpertise(id) {
      ExpertiseService.saveEndMainDocESExpertise(
        this.$route.params.id,
        id
      ).then(({ data }) => {
        if (!data.error) {
          this.$toasted.show("Экспертиза завершена", {
            theme: "green",
            position: "bottom-right",
            duration: 3000
          });
          this.fetchExpertise();
        } else if (data.error) {
          data.errorArr.forEach(function(text) {
            this.$toasted.show(text, {
              theme: "red",
              position: "bottom-right",
              duration: 8000
            });
          }, this);
        }
      }, this);
    },
    saveEndMainDocESExpertiseDop(id) {
      ExpertiseService.saveEndMainDocESExpertiseDop(
        this.$route.params.id,
        id
      ).then(({ data }) => {
        if (!data.error) {
          this.$toasted.show("Экспертиза завершена", {
            theme: "green",
            position: "bottom-right",
            duration: 3000
          });
          this.fetchExpertise();
        } else if (data.error) {
          data.errorArr.forEach(function(text) {
            this.$toasted.show(text, {
              theme: "red",
              position: "bottom-right",
              duration: 3500
            });
          }, this);
        }
      }, this);
    },
    updateExpertiseComment() {
      ExpertiseService.saveCommentManagerMainDocESExpertise(
        this.$route.params.id,
        {
          UF_COMMENT_STATUS_M: this.project.UF_COMMENT_STATUS_M
        }
      ).then(() => {}, this);
    },
    saveCommentExpertises(idExp, expertiseComment) {
      ExpertiseService.saveCommentExpertises(this.$route.params.id, idExp, {
        UF_EXPERTISE_COMMENT: expertiseComment
      }).then(({ data }) => {
        if (!data.error) {
          this.$toasted.show("Комментарий сохранен", {
            theme: "green",
            position: "bottom-right",
            duration: 3000
          });
        } else if (data.error) {
          data.errorArr.forEach(function(text) {
            this.$toasted.show(text, {
              theme: "red",
              position: "bottom-right",
              duration: 3500
            });
          }, this);
        }
      }, this);
    },
    saveCommentExpertisesDop(idExp, expertiseComment) {
      ExpertiseService.saveCommentExpertisesDop(this.$route.params.id, idExp, {
        UF_EXPERTISE_COMMENT_DOP: expertiseComment
      }).then(({ data }) => {
        if (!data.error) {
          this.$toasted.show("Комментарий сохранен", {
            theme: "green",
            position: "bottom-right",
            duration: 3000
          });
        } else if (data.error) {
          data.errorArr.forEach(function(text) {
            this.$toasted.show(text, {
              theme: "red",
              position: "bottom-right",
              duration: 3500
            });
          }, this);
        }
      }, this);
    },
    deleteExpertise(id) {
      if (confirm("Удалить экспертизу?")) {
        ExpertiseService.deleteMainDocESExpertise(
          this.$route.params.id,
          id
        ).then(({ data }) => {
          if (!data.error) {
            this.fetchExpertise();
          } else if (data.error) {
            data.errorArr.forEach(function(text) {
              this.$toasted.show(text.TEXT, {
                theme: "red",
                position: "bottom-right",
                duration: 3500
              });
            }, this);
          }
        }, this);
      }
    },
    closeECP(id) {
      this.resultECP[id] = !this.resultECP[id];
    },
    getECPInfo(idFile) {
      Vue.set(this.resultECP, [idFile], true);
      ProjectsService.getECPInfoFile(this.$route.params.id, idFile).then(
        ({ data }) => {
          this.result = data.result;
          this.resultECP[idFile] = true;
        }
      );
    },
    getLinkFileECP(id, format) {
      ProjectsService.getLinkFileECP(this.$route.params.id, id, format).then(
        ({ data }) => {
          window.location.href =
            AUTH_URL.replace(new RegExp("[\\/]+$"), "") + data.link;
        }
      );
    },
    deleteFile(id) {
      ProjectsService.deleteDocument(this.$route.params.id, id).then(
        response => {
          if (response.data.result) {
            this.$toasted.show("Файл успешно удален", {
              theme: "green",
              position: "bottom-right",
              duration: 3000
            });
            this.fetchExpertise();
          } else {
            response.data.error.forEach(function(text) {
              this.$toasted.show(text.TEXT, {
                theme: "red",
                position: "bottom-right",
                duration: 3500
              });
            }, this);
          }
        },
        this
      );
    },
    getFileHistory(id) {
      ProjectsService.getHistoryVersionDocument(this.$route.params.id, id).then(
        ({ data }) => {
          console.log(data.FILE_VERSION_HISTORY);
          this.showDocHistoryDialog = true;
          this.documentHistory = data.FILE_VERSION_HISTORY;
        },
        this
      );
    },
    getECPHistoryInfo(idFile) {
      if (this.result[idFile] !== undefined) {
        Vue.set(this.resultECP, [idFile], true);
      } else {
        ProjectsService.getECPInfoHistoryFile(
          this.$route.params.id,
          idFile
        ).then(({ data }) => {
          Vue.set(this.result, [idFile], data.result);
          Vue.set(this.resultECP, [idFile], true);
        });
      }
    },
    getFileName(file) {
      let p = file.split("/");
      return p[p.length - 1];
    },
    getStatus: function(id) {
      let t = this.directory.status.filter(c => c.ID === id);
      if (t.length > 0) {
        return t[0];
      }
    },
    filterItemText(count) {
      console.log(count);
      return ``;
    },

    isNumber: function(evt, val, procent) {
      evt = evt ? evt : window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;

      if (!procent && charCode === 46) {
        evt.preventDefault();
        return false;
      }
      if (
        procent &&
        charCode === 46 &&
        typeof val.indexOf !== "undefined" &&
        val.indexOf(".") !== -1
      ) {
        evt.preventDefault();
        return false;
      }
      if (procent === 1 && charCode === 46) {
        return true;
      }

      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },

    checkValueProcent: function(val) {
      if (val > 100) {
        val = 100;
      }
      return val;
    },
    saveFinanceIRR: function(val, expId, nameField, nameLabel) {
      ExpertiseService.editExpertiseField(
        this.$route.params.id,
        expId,
        nameField,
        {
          VALUE: val
        }
      ).then(({ data }) => {
        if (data.error) {
          this.$toasted.show(data.errorArr[0].TEXT, {
            theme: "red",
            position: "bottom-right",
            duration: 3500
          });
        } else {
          this.$toasted.show(
            "Запрос на изменение " + nameLabel + " успешно выполнен",
            {
              theme: "green",
              position: "bottom-right",
              duration: 3000
            }
          );
        }
      });
    }
  },
  async created() {
    this.siteUrl = AUTH_URL.replace(new RegExp("[\\/]+$"), "");
    await this.$store
      .dispatch(FETCH_DIRECTORY, ["status"])
      .then(() => {}, this);

    await this.$store
      .dispatch(FETCH_DIRECTORY, ["status_expertise"])
      .then(() => {}, this);

    await this.$store
      .dispatch(FETCH_DIRECTORY, ["type_provision_sp"])
      .then(() => {}, this);

    await this.$store
      .dispatch(FETCH_DIRECTORY, ["sp_variant_zalog_expertise"])
      .then(() => {}, this);

    await this.$store
      .dispatch(FETCH_DIRECTORY, ["sp_duration_expertise"])
      .then(() => {}, this);

    await this.$store
      .dispatch(FETCH_DIRECTORY, ["departaments"])
      .then(() => {}, this);

    await this.$store
      .dispatch(FETCH_DIRECTORY, ["sp_time_status_set_expertise"])
      .then(() => {}, this);

    await this.$store
      .dispatch(FETCH_DIRECTORY, ["sp_expertise_type_fie"])
      .then(() => {}, this);

    await this.$store
      .dispatch(FETCH_DIRECTORY, ["sp_expertise_type_pre"])
      .then(() => {}, this);

    this.$store.dispatch(FETCH_DIRECTORY, ["program_fin_support"]).then(() => {
      this.fetchProject();
      this.isLoadingComponent = true;
    }, this);
  }
};
</script>

<style scoped></style>
